export const LOCALES = Array.isArray(window.LOCALES) ? window.LOCALES : [];

export const IS_WITH_LOCALIZATION = LOCALES.length;

export const DEFAULT_LOCALE = LOCALES[0];

export const LOCALIZATION_WILDCARD = '{{x}}';
export const LOCALIZATION_SECOND_WILDCARD = '{{y}}';
export const LOCALIZATION_WILDCARDS_LIST = [LOCALIZATION_WILDCARD, LOCALIZATION_SECOND_WILDCARD];
